import { supabase } from './supabase'

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

export async function subscribeToPushNotifications(): Promise<boolean> {
  const vapidPublic = import.meta.env.VITE_VAPID_PUBLIC_KEY
  if (!vapidPublic || !supabase) return false

  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return false
  }

  const permission = await Notification.requestPermission()
  if (permission !== 'granted') return false

  const registration = await navigator.serviceWorker.ready
  const applicationServerKey = urlBase64ToUint8Array(vapidPublic) as BufferSource
  const sub = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey,
  })

  const json = sub.toJSON()
  const endpoint = json.endpoint
  const key = json.keys
  if (!endpoint || !key?.p256dh || !key?.auth) return false

  const user = (await supabase.auth.getUser()).data.user
  if (!user) return false

  const { error } = await supabase.from('push_subscriptions').upsert(
    {
      profile_id: user.id,
      endpoint,
      p256dh: key.p256dh,
      auth: key.auth,
      user_agent: navigator.userAgent.slice(0, 512),
    },
    { onConflict: 'profile_id,endpoint' },
  )

  return !error
}

export async function unsubscribeAllPushNotifications(): Promise<void> {
  if (!supabase) return
  const registration = await navigator.serviceWorker?.ready
  const sub = await registration?.pushManager.getSubscription()
  const endpoint = sub?.endpoint
  await sub?.unsubscribe()

  const user = (await supabase.auth.getUser()).data.user
  if (!user || !endpoint) return

  await supabase
    .from('push_subscriptions')
    .delete()
    .eq('profile_id', user.id)
    .eq('endpoint', endpoint)
}
